// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pOqB","colBig":"styles_colBig__ZBZbU","colSmall":"styles_colSmall__3kHQ7"};